import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dashBoardReportAction, dashBoardReportRegisteredUsersAction, dashBoardReportWorkOutSessionsAction } from "../../Redux/Actions/DashboardReportAction";
import { secondsToHHMMSS, sumOfRecordCounts, sumOfRecordCountsWithoutDecimal } from "../../helper/utility";
import { Constants } from "../Common/Constants";
import AreaGraph from "../Common/Graphs/AreaGraph";
import LineGraph from "../Common/Graphs/LineGraph";


dayjs.extend(utc);
dayjs.extend(timezone);


const Weekly = () => {
  // const { dashboardData } = useSelector((store) => store.Dashboard);
  const { male, female, total } = useSelector((store) => store.dashBoardReportReducer.activeUsers);
  const uniqueActiveUsersMale = useSelector((store) => store.dashBoardReportReducer.activeUsers.uniqueActiveUsers.male);
  const uniqueActiveUsersFemale = useSelector((store) => store.dashBoardReportReducer.activeUsers.uniqueActiveUsers.female);
  const registeredUsers = useSelector((s) => s.dashBoardReportReducer.registeredUsers);
  const workOutSessions = useSelector((store) => store.dashBoardReportReducer.workOutSessions);
  const totalDuration = useSelector((store) => store.dashBoardReportReducer.totalDuration);


  // const sumOfRegisteredUsers = registeredUsers.recordcounts.reduce((acc, curr) => acc + curr, 0).toFixed(2);
  const sumOfRegisteredUsers = sumOfRecordCountsWithoutDecimal(registeredUsers);
  // const sumOfWorkoutSessions = workOutSessions.recordcounts.reduce((acc, curr) => acc + curr, 0).toFixed(2);
  const sumOfWorkoutSessions = sumOfRecordCountsWithoutDecimal(workOutSessions);
  const sumOfTotalDuration = sumOfRecordCounts(totalDuration);
  // const sumOfMale = sumOfRecordCounts(male);
  // const sumOfFemale = sumOfRecordCounts(female);
  // const sumOfTotal = sumOfRecordCounts(total);


  const dispatch = useDispatch();

  useEffect(function () {
    const today = new Date();

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    // const formattedDate = today.toISOString().split("T")[0];
    const formattedDate = tomorrow.toISOString().split("T")[0];
    const tz = dayjs.tz.guess();

    dispatch(dashBoardReportAction({ noOfDays: 7, currentDate: formattedDate, tz }));
    dispatch(dashBoardReportRegisteredUsersAction({ noOfDays: 7, currentDate: formattedDate, tz }));
    dispatch(dashBoardReportWorkOutSessionsAction({ noOfDays: 7, currentDate: formattedDate, tz }));
  }, []);

  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={dashboardData?.registeredUserweek}
          data={registeredUsers}
          // title={Constants.totalRegisteredUsers}
          title={`${Constants.totalRegisteredUsers} ${sumOfRegisteredUsers}`}

          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={dashboardData?.totalActiveUserWeek}
          data={total}
          // title={Constants.totalActiveUsers}
          // title={`${Constants.totalActiveUsers} ${sumOfTotal}`}
          title={`${Constants.totalActiveUsers} ${uniqueActiveUsersMale ? uniqueActiveUsersMale + uniqueActiveUsersFemale : 0}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={dashboardData?.activeMaleUsersweek}
          data={male}
          // title={Constants.totalActiveUsersMale}
          // title={`${Constants.totalActiveUsersMale} ${sumOfMale}`}
          title={`${Constants.totalActiveUsersMale} ${uniqueActiveUsersMale || 0}`}

          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <LineGraph
          data={female}
          // data={dashboardData?.activeFeMaleUsersweek}
          // title={Constants.totalActiveUsersFemale}
          // title={`${Constants.totalActiveUsersFemale} ${sumOfFemale}`}
          title={`${Constants.totalActiveUsersFemale} ${uniqueActiveUsersFemale || 0}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <LineGraph
          // data={dashboardData?.last7daysSession}
          data={workOutSessions}
          // title={Constants.totalWorkoutSessions}
          title={`${Constants.totalWorkoutSessions} ${sumOfWorkoutSessions}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <LineGraph
          // data={dashboardData?.avgWorkoutDurationweekly}
          data={totalDuration}
          // title={Constants.totalWorkoutSessionDuration}
          title={`${Constants.totalWorkoutSessionDuration} ${secondsToHHMMSS(sumOfTotalDuration)}`}
          format=""
          yAxisType={"time"}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Weekly;
